<template>

	<div>
        <div class="row">
	        <div class="h1 page-header">
	            Newsfeed
	            <span class="pull-right">
	            <button class="btn btn-primary noprint" v-if="canManagePosts" v-on:click="addNewPost" v-show="!editMode">New Post</button>
	            <button class="btn btn-danger noprint" v-if="canManagePosts" v-on:click="cancelPostForm" v-show="editMode">Cancel</button>
	            <button class="btn btn-success noprint" v-if="canManagePosts" v-on:click="submitPostForm" v-show="editMode"><i class="fas fa-save"></i>&nbsp;Save Post</button>
		        </span>
	        </div>
	    </div>

	    <div class="row">
			<post-form ref="postForm" v-show="editMode" :can-manage-posts="canManagePosts" v-on:post_saved="handlePostSaved" v-on:cancel="handlePostCancelled" :post-id="selectedPostId"></post-form>
		</div>

        <posts-list ref="postsList" v-show="!editMode" :can-manage-posts="canManagePosts" v-on:edit_post="editPost" v-on:add_new_post="addNewPost" :club-id="clubId" :user-id="userId" :filter-only-published=false :filter-only-published-on-newsfeed=false :filter-only-published-on-website=false  ></posts-list>

	</div>

</template>

<style scoped>
</style>
	
<script>
	export default {
        props: [
            'clubId',
            'userId',
            'canManagePosts'
        ],
		data: function () {
				return {
					editMode: false,
					selectedPostId: null
				}
		},
		computed: {
		},
		mounted() {
				console.log('Newsfeed Page component mounted.');
		},
		methods: {
			addNewPost() {
				this.editMode = true;
				this.$refs.postForm.setPostId(null);
				this.$refs.postForm.init();
			},
			hideNewRecordForm() {
				this.editMode = false;
			},
			editPost(postId) {
				this.selectedPostId = postId;
				this.$refs.postForm.setPostId(postId);
				this.$refs.postForm.init();
				this.editMode = true;
			},
			cancelPostForm() {
				this.$refs.postForm.cancel();
			},
			submitPostForm() {
				this.$refs.postForm.submit();
			},
			handlePostSaved(message) {
				this.$message({message: message, type: 'success'});
				this.hideNewRecordForm();
				this.$refs.postsList.loadPosts();
			},
			handlePostCancelled() {
				this.hideNewRecordForm();
				this.$message({message: "Your changes have been cancelled", type: 'error'});
			}
		}
	}
</script>